import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
import { DatastoreService } from '../../services';
import { chapterLoginUrl } from '../../services/chapter-url';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	goToWebsite() {
		window.open(
			'https://www.solihull.gov.uk/',
			'_blank',
			'noopener,noreferrer'
		);
	}

	// Chapter: the customer's ceremony portal for this tenant.
	login() {
		window.open(chapterLoginUrl(), '_blank');
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}

	imageDetail: ImageDetail = {
		alt: 'Solihull Metropolitan Borough Council',
		src: 'assets/images/solihull-logo.png',
		href: 'https://www.solihull.gov.uk/',
	};

	navigation: NavLink[] = [];
}
